"use client";

import { useEffect } from "react";

/**
 * Enregistre le service worker `/sw.js`, UNIQUEMENT en production.
 * En développement un SW casserait le HMR de Next/Turbopack, on s'abstient donc.
 * Aucune UI : pas de prompt d'installation custom (hors périmètre).
 */
export function ServiceWorkerRegistration() {
  useEffect(() => {
    if (process.env.NODE_ENV !== "production") return;
    if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) {
      return;
    }

    const register = () => {
      navigator.serviceWorker
        .register("/sw.js", { scope: "/" })
        .catch((error) => {
          // Échec non bloquant : l'app fonctionne sans le SW.
          console.error("Échec de l'enregistrement du service worker", error);
        });
    };

    // On attend le chargement complet pour ne pas concurrencer le rendu initial.
    if (document.readyState === "complete") {
      register();
    } else {
      window.addEventListener("load", register, { once: true });
      return () => window.removeEventListener("load", register);
    }
  }, []);

  return null;
}
